import { useState, useRef, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Auth, Hub } from "aws-amplify";
import { HttpMainApi } from "../../interface/main-api";
import { HttpUnAuthApi } from "../../interface/unauth-api";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
 
import { userState } from "../../interface/MainInterface";
 
import Toast from "../../utils/Toast";
import { Typography } from "@mui/material";
 
import { appConfig } from "../../config/Config";
import { AES, enc } from "crypto-js";
// 환경 확인
const isLocalhost =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";
 
const contentPath = isLocalhost ? "개발서버 로그인" : "로그인";
 
interface propsType {
  userState: userState;
}
 
const unAuthAPI = new HttpUnAuthApi();

const SsoLogin = (props: propsType) => {
  // url 가져오기
  const stateInfo: URLSearchParams = new URLSearchParams(window.location.search);
 
  function decodeJwtPayload(idToken: string) {
    const base64Url = idToken.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
    return JSON.parse(jsonPayload);
  }
 
  useEffect(() => {
    if (isLocalhost) console.log("로컬환경입니다");
    console.log("여기가 redirect 되는곳임.");
    console.log("userState : ", props.userState);
    // 통합인증 서버에서 인사이트랩스를 클릭하면 여기로 redirect - 테스트사이트에서 바로 code와 state 보내줄거.
    // code, state를 수신 - 없으면 리턴
    // 세션의 저장된 state와 수신한 state 비교하여 위변조 여부 확인 - CSRF 방지용?
    // 람다 호출
    //  naon 인증 서버에서 위변조 여부 확인
    //  code를 사용해 통합인증서버에 토큰요청
    //  id_token을 디코딩하여 사용자 정보 추출
    //  ddb조회해서 문제없는지확인 등록 인원인지 확인.
    // 코그니토 로그인.
    // procSesson();
    const ssoLogin = async () => {
      console.log("ssoLogin 시작");

      const iamBase = isLocalhost ? "https://deviamhart.ehyundai.com/iam" : "https://iamhart.ehyundai.com/iam";
      // const iamBase = "http://10.100.166.147:443/iam";
      // const iamBase = "http://10.100.166.147:80/iam";
 
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get("code") || "";
      const state = urlParams.get("state");
      console.log("code : ", code);
      console.log("state : ", state);
      // const redirectUri = window.location.origin + window.location.pathname;
      const redirectUri = "https://aitb.ai-lewis.com/ssologin";
      console.log("redirectUri : ", redirectUri);
 
      // 1. 최초 진입이면 IAM 로그인 페이지로로 리다이렉트
      if (!code) {
        console.log("[SSO] 최초 진입");
        const encodedRedirect = encodeURIComponent(redirectUri);
        console.log("[SSO] redirect주소 : ", encodedRedirect);
 
        const state = crypto.randomUUID();
        sessionStorage.setItem("oidc_state", state);
 
        const module = urlParams.get("module");
        const menu = urlParams.get("menu");
 
        const loginUrl = new URL(`${iamBase}/oauth2/authorize`);
        loginUrl.searchParams.set("client_id", isLocalhost ? process.env.REACT_APP_DEV_CLIENT_ID! : process.env.REACT_APP_PROD_CLIENT_ID!);
        loginUrl.searchParams.set("redirect_uri", redirectUri);
        loginUrl.searchParams.set("scope", "openid");
        loginUrl.searchParams.set("response_type", "code");
        loginUrl.searchParams.set("state", state);
        if (module) loginUrl.searchParams.set("module", module);
        if (menu) loginUrl.searchParams.set("menu", menu);
 
        console.log("IAM 로그인 페이지 이동 : ", loginUrl.toString());
 
        // 리다이렉트 호출 - 임시 주석 - 외부에서는 당연히안되니까
        if (!isLocalhost) {
          console.log("리다이렉트");
          window.location.href = loginUrl.toString();
          return;
        }
      }
 
      // 2. state 위변조 확인
      if (!isLocalhost) {
        console.log("[SSO] state 위변조 확인");
        const storedState = sessionStorage.getItem("oidc_state");
        if (state !== storedState) {
          alert("CSRF 검증 실패");
          return;
        }
      }
 
      try {
        // 3. token 요청
        console.log("[SSO] get token");
        const data = new URLSearchParams();
        data.append("grant_type", "authorization_code");
        data.append("code", code);
        data.append("redirect_uri", redirectUri);
        data.append("client_id", isLocalhost ? process.env.REACT_APP_DEV_CLIENT_ID! : process.env.REACT_APP_PROD_CLIENT_ID!);
        data.append("client_secret", isLocalhost ? process.env.REACT_APP_DEV_CLIENT_SECRET! : process.env.REACT_APP_PROD_CLIENT_SECRET!);
        console.log("[SSO] data : ", data);
        console.log("[SSO] data : ", data.toString());
        const ssoTokenURL = `${iamBase}/oauth2/token`;
 
        // 3.5 vpn 프록시 서버 호출
        const proxyURL = "https://vpn-proxy.vectocore.com/internal";
        const proxyHeaders = {
          "x-api-key": "6XMU104YEm2ac4xQWmi1TWtDEG2auzy1QC52vIr1",
        };
        const proxyBody = {
          command: "send_internal_request",
          url: ssoTokenURL,
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: data.toString(),
        };
 
        const tokenRes = await fetch(proxyURL, {
          method: "POST",
          headers: {
            ...proxyHeaders,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(proxyBody),
        });
        console.log("tokenRes: ", tokenRes);
 
        const tokenJson = await tokenRes.json();
        console.log("tokenJson:", tokenJson);
        if (tokenJson.code === "200") {
          const tokenData = tokenJson.data;
          const accessToken = tokenData.access_token;
          const idToken = tokenData.id_token;
          const refreshToken = tokenData.refresh_token;
          const tokenType = tokenData.token_type;
          const expiresIn = tokenData.expires_in;
          const scope = tokenData.scope;
 
          const claim = decodeJwtPayload(idToken);
          console.log("claim:", claim);
 
          const empNo = claim.emp_no;
          const name = claim.name;
 
          // 4. TODO: DDB 검증 → Cognito 로그인 → 세션 처리 등 이어서 구현
          check_user(empNo);
        }
        if (isLocalhost) {
          console.log("로컬 로그인 2311336");
          check_user("2311336");
        }
      } catch (e) {
        console.error("[SSO] 토큰 요청 실패", e);
        alert("로그인 중 오류 발생");
      }
    };
    ssoLogin();
  }, []);
 
  const check_user = async (key_id: string) => {
    console.log("check_user");
    // 코그니토 가입자만 사용해서.
    const param: any = {
      command: "get_hart_user_info",
      user_id: key_id,
    };
    const res = await unAuthAPI.post(param);
    console.log("res: ", res);
    if ("" + res.code == "200") {
      fnUserCount(key_id);
      procSession(res.response.user_info);
    } else {
      console.log("error_msg: ", res);
    }
  };
 
  const fnUserCount = async (userId: string) => {
    const param: any = {
      command: "update_user_count",
      user_id: userId,
    };
  
    const res = await unAuthAPI.post(param);
    if (res.code === "200") {
    }    
  };
  
  const procSession = (sessionData: any) => {
    const sessionObj: any = {
      id: sessionData.sk,
      isAdmin: sessionData.is_admin,
      isSuperAdmin: sessionData.is_super_admin,
      name: sessionData.name,
      userInfo1: sessionData.user_info1,
      userInfo2: sessionData.user_info2,
      userInfo3: sessionData.user_info3,
      userInfo4: sessionData.user_info4,
      expire: Date.now() + 1000 * 60 * 60 * 24, // 24시간
    };
    console.log("session 저장");
    const objString = JSON.stringify(sessionObj);
    const encObjString = AES.encrypt(objString, appConfig.seed).toString();
    window.localStorage.setItem(appConfig.sessionName, encObjString);

    window.location.href = "/";
  }
 
  return (
    <div className="wrapper hart-login">
      <div className="hart-login-box">
        {/* <h2>
          <img src="/images/bi-new.png" />
        </h2> */}
        <p>AITB </p>
        <div className="form-wrap"> H-art를 통해서 접속해주시기 바랍니다.</div>
        <div className="hart-footer">
          <p className="copyright">© Hyundai. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};
 
export default SsoLogin;